import axios from "axios"
import React, { useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import DatePicker from "react-datepicker"
import Select from "react-select"
import { useHistory } from "react-router-dom"
import { convertPermission } from "permissionUtils"

const FilterStatusHistory = ({
  filteredValues,
  setFilteredValues,
  setAuth,
}) => {
  const history = useHistory()

  const [users, setUsers] = useState([])

  // **************** Permissions ******************************
  const userPermissions = convertPermission(
    JSON.parse(localStorage.getItem("roles"))
  )
  // console.log("userPermissions", userPermissions)

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/MenuUsersView", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let data = Object.entries(res.data)
        data.splice(-1)
        let dataUsers = data.map(user => ({
          value: user[1].UserID,
          label: `${user[1].FirstName} ${user[1].LastName}`,
        }))
        setUsers(dataUsers)
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange

  // console.log("filteredValues", filteredValues)

  const convertDate = value => {
    let day = value.getDate() + ""
    day = day.length === 1 ? `0${day}` : day
    let month = value.getMonth() + 1 + ""
    month = month.length === 1 ? `0${month}` : month
    let year = value.getFullYear()
    return `${year}-${month}-${day}` || null
  }
  return (
    <Row>
      <Col sm={3}></Col>

      <Col md={3}>
        <div className="search-box me-3 col-12 p-0">
          <div className="position-relative mb-2 form-control border-dark py-0">
            <i className="bx bx-search-alt search-icon my-auto" />
            <Select
              isMulti
              options={users}
              name="users"
              className="react-select-container"
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderColor: state.isFocused ? "transparent" : "transparent",
                  borderColor: state.isSelected ? "transparent" : "transparent",
                  borderWidth: "0px",
                }),
              }}
              value={filteredValues.User}
              onChange={e => {
                // console.log(e)
                setFilteredValues({ ...filteredValues, User: e })
              }}
              classNamePrefix="select"
              placeholder="User ..."
              isDisabled={userPermissions.R3.G !== "1"}
            />
          </div>
        </div>
      </Col>

      <Col md={3}>
        <div className="search-box me-3 col-12">
          <div className="position-relative mb-2 form-control border-dark ">
            <i className="bx bx-search-alt search-icon" />
            <DatePicker
              isClearable
              className="border-0"
              selectsRange={true}
              dateFormat="yyyy/MM/dd"
              startDate={startDate}
              endDate={endDate}
              onChange={update => {
                setDateRange(update)
                setFilteredValues({
                  ...filteredValues,
                  StartDate: update[0] ? convertDate(update[0]) : null,
                  EndDate: update[1] ? convertDate(update[1]) : null,
                })
              }}
              // withPortal
              placeholderText="Date ..."
            />
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default FilterStatusHistory
